import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const solutionsPlugin = createPlugin({
  id: 'solutions',
  routes: {
    root: rootRouteRef,
  },
});

export const SolutionsPage = solutionsPlugin.provide(
  createRoutableExtension({
    name: 'SolutionsPage',
    component: () =>
      import('./components/SolutionListComponent').then(m => m.ListSolutionsComponent),
    mountPoint: rootRouteRef,
  }),
);
